module.exports = __webpack_public_path__ + "img/Сагакская-Наталья-Валентиновна-2.50e01bbe.png";